import * as q from '@Alternatives/Forms/Domain/queries';
import VueCqrs from '@cqrs/vue-component-cqrs';
import Component from 'vue-class-component';

@Component
export default class FormsQueries extends VueCqrs
{
	runFormsPageQueryV1(workspaceId: number, projectId: number)
	{
		const query = q.buildFormsPageQueryV1(workspaceId, projectId);
		this.$query(query);
	}

	runFormSettingsQueryV1(workspaceId: number, projectId: number, formId: number)
	{
		const query = q.buildFormSettingsQueryV1(workspaceId, projectId, formId);
		this.$query(query);
	}

	runFormByIdQueryV1(workspaceId: number, projectId: number, alternativesListId: number, formId: number)
	{
		const query = q.buildFormByIdQueryV1(workspaceId, projectId, alternativesListId, formId);
		this.$query(query);
	}

	runFormDependenciesQueryV1(workspaceId: number, projectId: number, alternativesListId: number, formId: number)
	{
		const query = q.buildFormDependenciesQueryV1(workspaceId, projectId, alternativesListId, formId);
		this.$query(query);
	}
}